import React, { useState } from "react";
import editIcon from "../../../assets/common/editBoxIcon.png";
import deleteIcon from "../../../assets/common/delete.svg";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import ConfirmationDialog from "components/common/ConfirmationDialog";
import { getCaseWorkFlowsItem } from "api";

const MessageDialog = ({ onClose }) => {
  return (
    <Dialog title={"Message"} onClose={onClose} width={450}>
      <p className="text-center fs-lg p-3">
        You are not allowed to delete a folder having subitems!
      </p>
      <div className="d-flex align-items-center justify-content-end mt-3 me-4 pe-1 pb-3">
        <Button className="button-small common-btn" onClick={onClose}>
          OK
        </Button>
      </div>
    </Dialog>
  );
};

export const MyCommandCell = (props) => {
  const { dataItem, appCode, edit, update } = props;
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  const handleDelete = async () => {
    const items = await getCaseWorkFlowsItem(appCode, dataItem?.workflowId);
    if (items.data?.data?.length === 0) {
      setShowDeleteConfirm(true);
    } else {
      setShowMessage(true);
    }
  };

  return (
    <td className="k-command-cell d-flex my-2 justify-content-center flex-nowrap">
      <img
        className="cursor-pointer me-3"
        onClick={() => edit(dataItem)}
        src={editIcon}
        style={{ width: "20px", height: "20px" }}
        alt="Edit"
      />

      <img
        className="cursor-pointer me-2"
        onClick={handleDelete}
        src={deleteIcon}
        style={{ width: "20px", height: "20px" }}
        alt="Delete"
      />

      {showDeleteConfirm && (
        <ConfirmationDialog
          content={`Are you sure you want to remove ${
            dataItem.workflowItemsType === 0
              ? "folder"
              : dataItem.workflowItemsType
          } "${dataItem.name}"`}
          onClickYes={() => {
            update(dataItem, false);
            setShowDeleteConfirm(false);
          }}
          onClickNo={() => setShowDeleteConfirm(false)}
          onClose={() => setShowDeleteConfirm(false)}
        />
      )}

      {showMessage && <MessageDialog onClose={() => setShowMessage(false)} />}
    </td>
  );
};
